import React from 'react'
import Appbar from '../components/bars/Appbar'
import Tabbar from '../components/bars/Tabbar'

function Messages() {
  return (
    <div className='mw'>
      <div className="screen">
        <Appbar show='flex' />
        <h1 className="title">Messages</h1>
        <Tabbar show='flex' />
      </div>
    </div>
  )
}

export {Messages}
